import { createAction, handleActions } from 'redux-actions'
import * as globalMessageActions from '../global-message'
import api from '../api'
import Y from '../../y18n'

const CONTACT_US = createAction('email/CONTACT_US')
const CONTACT_US_SUCCESS = createAction('email/CONTACT_US_SUCCESS')
const CONTACT_US_ERROR = createAction('email/CONTACT_US_ERROR')

const CHECK_EMAIL = createAction('email/CHECK_EMAIL')
const CHECK_EMAIL_SUCCESS = createAction('email/CHECK_EMAIL_SUCCESS')
const CHECK_EMAIL_ERROR = createAction('email/CHECK_EMAIL_ERROR')

const UNBLOCK_EMAIL = createAction('email/UNBLOCK_EMAIL')
const UNBLOCK_EMAIL_SUCCESS = createAction('email/UNBLOCK_EMAIL_SUCCESS')
const UNBLOCK_EMAIL_ERROR = createAction('email/UNBLOCK_EMAIL_ERROR')

const RESET_STATUS = createAction('email/RESET_FORM')

const initialState = {
  loading: false,
  error: null,
  emailStatus: null,
  unblockStatus: null
}

export default handleActions(
  {
    [CONTACT_US]: (state, action) => ({
      ...state,
      loading: true
    }),
    [CONTACT_US_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [CONTACT_US_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [CHECK_EMAIL]: (state, action) => ({
      ...state,
      loading: true
    }),
    [CHECK_EMAIL_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      emailStatus: action.payload
    }),
    [CHECK_EMAIL_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [UNBLOCK_EMAIL]: (state, action) => ({
      ...state,
      loading: true
    }),
    [UNBLOCK_EMAIL_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      unblockStatus: action.payload
    }),
    [UNBLOCK_EMAIL_ERROR]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload
    }),
    [RESET_STATUS]: (state, action) => ({
      ...state,
      loading: false,
      emailStatus: null,
      unblockStatus: null,
      error: null
    })
  },
  initialState
)

export const sendContactEmail = model => {
  return dispatch => {
    dispatch(CONTACT_US())
    return api
      .post('email/contactUs', '', model)
      .then(result => {
        dispatch(CONTACT_US_SUCCESS())
        dispatch(globalMessageActions.setGlobalSuccess(Y`Email sent`))
      })
      .catch(error => {
        dispatch(CONTACT_US_ERROR(error))
        dispatch(globalMessageActions.setGlobalError(Y`An error occured. Please try again`))
      })
  }
}

export const checkEmailStatus = email => {
  return dispatch => {
    dispatch(CHECK_EMAIL())
    return api
      .get('email/checkEmailStatus', '', `email=${email}`)
      .then(result => {
        dispatch(CHECK_EMAIL_SUCCESS(result))
      })
      .catch(error => {
        dispatch(CHECK_EMAIL_ERROR())
      })
  }
}

export const unblockEmail = email => {
  return dispatch => {
    dispatch(UNBLOCK_EMAIL())
    return api
      .post('email/unblockEmail', '', email)
      .then(result => {
        dispatch(UNBLOCK_EMAIL_SUCCESS(result))
      })
      .catch(error => {
        dispatch(UNBLOCK_EMAIL_ERROR(error))
      })
  }
}

export const resetStatus = () => {
  return dispatch => {
    dispatch(RESET_STATUS())
  }
}



// WEBPACK FOOTER //
// ./src/store/email/index.js